import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FactSection } from './FactSection';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const f = (fact)=>fact;
/** Format a page limit with full scope-aware shape (per_instance, per_subsection). */ function formatPageLimit(p) {
    const unit = p.unit || 'pages';
    const base = `${p.limit} ${unit}`;
    if (p.scope === 'per_instance' && p.instanceLabel) {
        if (p.instanceMax && p.instanceMax > 0) {
            const label = p.instanceMax === 1 ? p.instanceLabel : pluralize(p.instanceLabel, p.instanceMax);
            return `${base} × ${p.instanceMax} ${label}`;
        }
        return `${base} per ${p.instanceLabel}`;
    }
    if (p.scope === 'per_subsection' && p.subsectionScope) {
        if (p.instanceMax && p.instanceMax > 0) {
            return `${base} per ${p.subsectionScope} · max ${p.instanceMax}`;
        }
        return `${base} per ${p.subsectionScope}`;
    }
    return base;
}
function pluralize(word, count) {
    if (count === 1) return word;
    const lower = word.toLowerCase();
    if (/[bcdfghjklmnpqrstvwxz]y$/.test(lower)) return `${word.slice(0, -1)}ies`;
    if (/(s|x|z|ch|sh)$/.test(lower)) return `${word}es`;
    return `${word}s`;
}
export function VolumesView({ pipeline, projectId }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-5",
        children: [
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Volume Structure",
                facts: pipeline.volumes ?? [],
                accent: "blue",
                projectId: projectId,
                titleFn: (v)=>f(v).displayName || f(v).name || f(v).identifier || 'Volume',
                metaFn: (v)=>[
                        f(v).fileFormat?.toUpperCase(),
                        f(v).requiredOptional
                    ].filter(Boolean).join(' · ') || undefined
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Page Limits",
                facts: pipeline.pageLimits ?? [],
                accent: "amber",
                projectId: projectId,
                titleFn: (v)=>formatPageLimit(f(v)),
                metaFn: (v)=>f(v).volumeName
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Format Rules",
                facts: pipeline.formatRules ?? [],
                accent: "green",
                projectId: projectId,
                titleFn: (v)=>f(v).value || 'Format rule',
                metaFn: (v)=>[
                        f(v).ruleType?.replace(/_/g, ' '),
                        f(v).volumeName
                    ].filter(Boolean).join(' · ')
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Content Requirements",
                facts: pipeline.contentRequirements ?? [],
                accent: "green",
                projectId: projectId,
                titleFn: (v)=>f(v).description || f(v).contentType?.replace(/_/g, ' ') || 'Content',
                metaFn: (v)=>f(v).volumeName
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "File Requirements",
                facts: pipeline.fileRequirements ?? [],
                accent: "green",
                projectId: projectId,
                titleFn: (v)=>f(v).fileFormat || f(v).namingConvention || 'File requirement',
                metaFn: (v)=>f(v).volumeName
            })
        ]
    });
}
